

























import { Component, Vue } from "vue-property-decorator";
import { Dialog, Empty, Toast } from "vant";

@Component({
  components: {
    [Dialog.Component.name]: Dialog.Component,
    [Empty.name]: Empty
  }
})
export default class LoginDevice extends Vue {
  deviceList = [];

  get bgColor() {
    return this.$store.getters["common/bgColor"];
  }

  created() {
    this.getDeviceList();
  }

  getDeviceList() {
    (this as any).$apis
      .loginDeviceList()
      .then(res => {
        this.deviceList = res || [];
      })
      .catch(e => {
        
      });
  }

  handleDelete(id) {
    (this as any).$apis
      .deleteDevice({ id })
      .then(res => {
        Toast(this.$t("security_center.login_device.operated"));
        setTimeout(() => {
          this.getDeviceList();
        }, 1500);
      })
      .catch(e => {
        
      });
  }

  deleteHandle(id) {
    Dialog.confirm({
      ["message" as any]: this.$t("security_center.login_device.del_text"),
      ["className" as string]: this.bgColor === "black-theme" ? "black-theme-dialog custom-confirm" : "custom-confirm",
      ["cancelButtonText" as any]: this.$t(
        "security_center.login_device.cancel_btn"
      ),
      ["confirmButtonText" as any]: this.$t(
        "security_center.login_device.ok_btn"
      )
    })
      .then(() => {
        this.handleDelete(id);
      })
      .catch(() => {
        // on cancel
      });
  }
}
